import axios from 'axios';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

const instance = axios.create({
    headers: {
        'X-CSRF-Token': csrfToken
    }
});

export default instance;